module.exports = __webpack_public_path__ + "img/banner广告管理.1860b611.png";